import { endOfToday, startOfToday } from 'date-fns';
import { ApplicationAction, ApplicationArea, LocationIconType } from '../types';
import { Icon } from '../../global';
// eslint-disable-next-line import/no-restricted-paths
import { MonitoringDateFilter } from '../../monitoring/types';

export const NAV_DRAWER_COLLAPSED_WIDTH = 56;
export const NAV_DRAWER_WIDTH = 224;

export const ROLE_DEFAULT_AREAS = {
  [ApplicationArea.MONITORING]: ApplicationAction.NONE,
  [ApplicationArea.PERSONNEL]: ApplicationAction.NONE,
  [ApplicationArea.PLACES]: ApplicationAction.NONE,
  [ApplicationArea.GEOFENCES]: ApplicationAction.NONE,
  [ApplicationArea.PROTOCOLS]: ApplicationAction.NONE,
  [ApplicationArea.REMINDERS]: ApplicationAction.NONE,
  [ApplicationArea.REPORTS]: ApplicationAction.NONE,
};
export const Icons: Icon[] = [
  {
    id: '1',
    type: LocationIconType.CIRCLE,
  },
  {
    id: '2',
    type: LocationIconType.SQUARE,
  },
  {
    id: '3',
    type: LocationIconType.TRIANGLE,
  },
  {
    id: '4',
    type: LocationIconType.RHOMBUS,
  },
  {
    id: '5',
    type: LocationIconType.CROSS,
  },
  {
    id: '6',
    type: LocationIconType.STAR,
  },
];

export const MAPBOX_API_KEY =
  'pk.eyJ1IjoidHllbmdpYmFyeWFuIiwiYSI6ImNtNG9taHpkajBtNmMyanIybWVydWJuMDQifQ.mBuGDqlE0Zk9q3pRhVGS1A';

export const DEFAULT_TEAM_NAME = 'Individuals';

export const LIST_DEFAULT_ITEM_LIMIT = 10;

export const DOT_CIRCLE_SHAPE = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  minWidth: 8,
};

export const DOT_CIRCLE_SHAPE_SMALL = {
  width: 4,
  height: 4,
  borderRadius: '50%',
  minWidth: 4,
};

export const LOCAL_STORAGE_KEYS = {
  MONITORING_EVENT_SELECTED_CONTROLS: 'MONITORING_EVENT_SELECTED_CONTROLS',
  MONITORING_EVENT_CONTROLS_OPEN: 'MONITORING_EVENT_CONTROLS_OPEN',
  MONITORING_SIDEBAR_COLLAPSE_STATE: 'MONITORING_SIDEBAR_COLLAPSE_STATE',
};

export class SFOverlayManager {
  overlayId = '';

  subscribers: Array<(id: string) => void>;

  constructor() {
    this.subscribers = [];
  }

  subscribe(callback: (id: string) => void) {
    this.subscribers.push(callback);
  }

  unsubscribe(callback: (id: string) => void) {
    this.subscribers = this.subscribers.filter(
      (subscriber) => subscriber !== callback,
    );
  }

  setOverlayId(id: string) {
    this.overlayId = id;
    this.subscribers.forEach((subscriber) => subscriber(id));
  }
}

export const mapOverlayManager = new SFOverlayManager();

export enum AntennaSignalQuality {
  NO_SIGNAL = 'NO_SIGNAL',
  VERY_WEAK = 'VERY_WEAK',
  WEAK = 'WEAK',
  STRONG = 'STRONG',
  VERY_STRONG = 'VERY_STRONG',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
  NONE = 'NONE',
}

export const DATE_FILTER_DEFAULTS = {
  defaultStartDate: startOfToday().getTime(),
  defaultEndDate: endOfToday().getTime(),
  defaultFilterValue: 'today' as MonitoringDateFilter,
  defaultStartHour: '00:00',
  defaultEndHour: '23:59',
  defaultExcludeWeekends: 'false',
};
